/* istanbul ignore file */

import * as Contentful from './useContentfulContentTypeEntries';

/**
 * Mocks `useContentfulContentTypeEntries` hook using `jest.spyOn`.
 *
 * @example
 *
 * mockUseContentfulContentTypeEntries({
 *  shouldMockReturnValueOnce: true,
 *  returnValue: {
 *   data: [{...}, {...}],
 *   fetching: false,
 *   error: undefined
 *  }
 * });
 */
export function mockUseContentfulContentTypeEntries(
  props?: MockUseContentfulContentTypeEntriesProps,
) {
  const { returnValue, shouldMockReturnValueOnce } = props ?? {};

  const returnValueMock = {
    data: undefined,
    fetching: false,
    error: undefined,
    ...returnValue,
  };

  // ─────────────────────────────────────────────────────────────────────

  if (shouldMockReturnValueOnce) {
    jest.spyOn(Contentful, 'useContentfulContentTypeEntries').mockReturnValueOnce(returnValueMock);

    return;
  }

  jest.spyOn(Contentful, 'useContentfulContentTypeEntries').mockReturnValue(returnValueMock);
}

// ─── Types ───────────────────────────────────────────────────────────────────

type MockUseContentfulContentTypeEntriesProps = Readonly<{
  shouldMockReturnValueOnce?: boolean;
  returnValue?: Partial<ContentTypeEntries>;
}>;

type ContentTypeEntries = Partial<ReturnType<typeof Contentful.useContentfulContentTypeEntries>>;
